import React from 'react';

const CheckmarkGreen = () => (
  <svg width="13" height="11" viewBox="0 0 13 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 5.33335L5 9.00002L12 1.66669" stroke="#006351" strokeWidth="2" strokeMiterlimit="10" />
  </svg>
);

export default CheckmarkGreen;
